import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "@fontsource/open-sans";
import './fonts.css'

// Import <SaltProviderNext>
import {SaltProviderNext} from "@salt-ds/core";

// Import theme CSS
import "@salt-ds/theme/index.css";
import "@salt-ds/theme/css/theme-next.css";

import { IntlProvider } from 'react-intl';
import Cookies from 'js-cookie';

import enLocaleData from './locale/en.json';
import { DensityProvider, useDensity } from './DensityContext';
const localeData = { 'en': enLocaleData };
const locale = Cookies.get('locale') || 'en';

const root = ReactDOM.createRoot(document.getElementById('root'));

function Main() {
  const density = useDensity();

  return (
    <IntlProvider locale={locale} messages={localeData[locale]} >
      <SaltProviderNext
        accent="teal"             // or "blue"
        corner="rounded"          // or "sharp"
        headingFont="Amplitude"   // or "Open Sans"
        actionFont="Amplitude"    // or "Open Sans"
        density={density}         // Use the dynamic density value
      >
        <App />
      </SaltProviderNext>
    </IntlProvider>
  );
}

root.render(
  <React.StrictMode>
    <DensityProvider>
      <Main />
    </DensityProvider>
  </React.StrictMode>,
);